export default __webpack_public_path__ + "static/media/Group.4c2d482b.jpg";